import {
  Activity,
  Building2,
  ChartColumnIncreasing,
  CheckCircle2,
  HeartPulse,
  ShieldCheck,
  Users
} from 'lucide-react';

export type Feature = {
  title: string;
  description: string;
  bullets: string[];
  icon: typeof Activity;
  mockup: 'planning' | 'monitoring' | 'injury';
};

export type Plan = {
  name: string;
  description: string;
  monthlyPrice: string;
  annualPrice: string;
  bullets: string[];
  icon: typeof Users;
  highlighted?: boolean;
};

export const DOWNLOAD_LINK = 'https://onelink.to/zm4exa';
export const HEADLINE_LINK = 'https://walink.co/8m2vpn';

export const heroCopy = {
  title: 'Plataforma profesional de entrenamiento',
  subtitle:
    'Planificación, monitoreo de carga y prevención de lesiones para profesionales del entrenamiento.',
  primaryCta: 'Descargar'
};

export const trustLogos = ['Clubes', 'Preparadores', 'Institutos', 'Selecciones', 'Academias'];

export const features: Feature[] = [
  {
    title: 'Planes de entrenamiento',
    description:
      'Biblioteca de ejercicios y cronología para optimizar planes de entrenamiento en todas las etapas.',
    bullets: [
      'Fuerza, core, movilidad, flexibilidad y velocidad.',
      'Soporte audiovisual y edición en cada ejercicio.',
      'Creación de planes rápida y seguimiento constante de atletas.'
    ],
    icon: Activity,
    mockup: 'planning'
  },
  {
    title: 'Monitoreo de la carga',
    description:
      'Herramientas profesionales para medir y evaluar la carga de entrenamiento de tus deportistas individualmente.',
    bullets: [
      'Cuestionarios wellness integrados.',
      'Test TQR y RPE.',
      'Cálculo de unidades arbitrarias y tendencias semanales.'
    ],
    icon: ChartColumnIncreasing,
    mockup: 'monitoring'
  },
  {
    title: 'Prevención de lesiones',
    description:
      'Herramientas de evaluación y monitoreo para la prevención de lesiones en deportistas.',
    bullets: [
      'Monitoreo de riesgo e historial por atleta.',
      'Control de estabilidad y balance.',
      'Base de evidencia para decisiones más seguras.'
    ],
    icon: HeartPulse,
    mockup: 'injury'
  }
];

export const institutionCopy = {
  title: '+Trainer para instituciones',
  description:
    'Una solución centralizada para coordinar equipos, staff técnico y seguimiento de rendimiento con una experiencia clara para cada rol.'
};

export const subscriptionPlans: Plan[] = [
  {
    name: 'Licencia Entrenador',
    description:
      'Planificación de entrenamientos con biblioteca audiovisual, monitoreo de carga y prevención de lesiones basada en evidencia.',
    monthlyPrice: 'US$ 9,99',
    annualPrice: 'US$ 99,99',
    bullets: [
      'Gestión de atletas y seguimiento en un solo lugar.',
      'Plantillas y progresiones reutilizables.',
      'Acceso completo a herramientas de campo.'
    ],
    icon: ShieldCheck
  },
  {
    name: 'Instituciones',
    description:
      'Ideal para clubes, academias e instituciones que necesitan visibilidad total del rendimiento y colaboración entre áreas.',
    monthlyPrice: 'US$ 99,99',
    annualPrice: 'Personalizado',
    bullets: [
      'Acceso multi-rol con permisos administrables.',
      'Reportes por sede, disciplina y período.',
      'Soporte dedicado para implementación y escalado.'
    ],
    icon: Building2,
    highlighted: true
  }
];

export const ctaCopy = {
  title: '¿Listo para llevar tu manera de trabajar al siguiente nivel?',
  subtitle:
    'Sumate a +Trainer y transformá la gestión diaria de tus entrenamientos con datos claros y decisiones más inteligentes.',
  button: 'Descargar'
};

export const footerBullets = ['Producto', 'Instituciones', 'Soporte', 'Contacto'];

export const checkIcon = CheckCircle2;
